import { validateEmail } from "utils";

export const brands = {
  vitality: "Vitality"
};

export const determineBrandBasedOnUrl = () => {
  const pathArray = window.location.pathname.split("/");
  const selectedBrand = pathArray.find(path => brands[path]);
  return selectedBrand;
};

export const validateCustomerEmail = email => {
  if (!validateEmail(email)) {
    return "Please enter a valid email";
  }
  return null;
};

export const validateMembershipNumber = number => {
  if (number[0] !== "1" || number.length !== 10) {
    return "Invalid membership number";
  }
  return null;
};
